import React from 'react'
import Switch from '@mui/material/Switch'
import { Box, Typography } from '@mui/material'
import { makeStyles, withStyles } from '@mui/styles'
import clsx from 'clsx'
import { shouldFlip } from 'stories/helpers/theme'

const MuiSwitch = withStyles((theme) => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
  },
  switchBase: {
    padding: 2,
    color: theme.palette.grey[500],
    left: shouldFlip(theme) ? '-12px' : 0,
    '&$checked': {
      transform: 'translateX(12px)',
      color: theme.palette.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
      },
    },
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: 'none',
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.white,
  },
  checked: {},
}))(Switch)

const useStyles = makeStyles((theme) => ({
  toggle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1),
    border: `1px solid ${theme.palette.gray.main}`,
    minHeight: 50,
    borderRadius: 5,
    '&:hover': {
      borderColor: 'black',
    },
    '&>p': {
      width: '80%',
    },
  },
  error: {
    borderColor: theme.palette.error,
  },
  disabled: {
    filter: 'grayscale(1)',
    color: 'gray',
  },
  disableBorder: {
    border: 'none',
  },
}))
export default function CustomizedSwitches({ error, disableBorder, ...props }) {
  const classes = useStyles()
  return (
    <Box
      className={clsx({
        [classes.toggle]: true,
        [classes.error]: error,
        [classes.disabled]: props.disabled,
        [classes.disableBorder]: disableBorder,
      })}
    >
      <Typography variant="caption" component="p">
        {props.label}
      </Typography>
      <MuiSwitch {...props} checked={props.checked || props.value || false} />
    </Box>
  )
}
